import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { PARAMETRO_RETORNO_LOGIN } from '../guards/auth.guard';
import { AppConfigService } from '../services/app-config.service';
import { AuthService } from '../services/auth/auth.service';
import { REDIRECIONAR_EM_401 } from './auth-interceptor.context';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const appConfig = inject(AppConfigService);
    const auth = inject(AuthService);
    const router = inject(Router);

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && appConfig.loginObrigatorio() && req.context.get(REDIRECIONAR_EM_401)) {
                auth.logout();
                void router.navigate(['/login'], { queryParams: { [PARAMETRO_RETORNO_LOGIN]: router.url } });
            }
            return throwError(() => error);
        })
    );
};
